export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_DOCTOR_REQUEST = "FETCH_DOCTOR_REQUEST";
export const UPDATE_DOCTOR_REQUEST = "UPDATE_DOCTOR_REQUEST";
export const CREATE_DOCTOR_PROFESSION_REQUEST = "CREATE_DOCTOR_PROFESSION_REQUEST";
export const UPDATE_DOCTOR_PROFESSION_REQUEST = "UPDATE_DOCTOR_PROFESSION_REQUEST";
export const DELETE_DOCTOR_PROFESSION_REQUEST = "DELETE_DOCTOR_PROFESSION_REQUEST";
export const CHANGE_DOCTOR_STATUS_REQUEST = "CHANGE_DOCTOR_STATUS_REQUEST";
export const CHANGE_DOCTOR_WEIGHT_REQUEST = "CHANGE_DOCTOR_WEIGHT_REQUEST";
export const CREATE_DOCTOR_INSURANCE_REQUEST = "CREATE_DOCTOR_INSURANCE_REQUEST";
export const DELETE_DOCTOR_INSURANCE_REQUEST = "DELETE_DOCTOR_INSURANCE_REQUEST";
export const CHANGE_DOCTOR_IS_IN_CAMPAIGN_REQUEST = "CHANGE_DOCTOR_IS_IN_CAMPAIGN_REQUEST";
export const UPDATE_DOCTOR_IMAGE_REQUEST = "UPDATE_DOCTOR_IMAGE_REQUEST";
export const DELETE_DOCTOR_IMAGE_REQUEST = "DELETE_DOCTOR_IMAGE_REQUEST";
export const UPDATE_DOCTOR_VERIFIED_REQUEST = "UPDATE_DOCTOR_VERIFIED_REQUEST";
export const UPDATE_DOCTOR_HAS_FOREIGN_CONSULT_REQUEST = "UPDATE_DOCTOR_HAS_FOREIGN_CONSULT_REQUEST";
export const UPDATE_DOCTOR_PACKAGE_REQUEST = "UPDATE_DOCTOR_PACKAGE_REQUEST";
export const UPDATE_DOCTOR_PACKAGE_STATUS_REQUEST = "UPDATE_DOCTOR_PACKAGE_STATUS_REQUEST";
export const FETCH_DOCTOR_PACKAGE_REQUEST = "FETCH_DOCTOR_PACKAGE_REQUEST";
export const FETCH_DOCTOR_PACKAGE_PRICES_REQUEST = "FETCH_DOCTOR_PACKAGE_PRICES_REQUEST";
export const CREATE_DOCTOR_PACKAGE_REQUEST = "CREATE_DOCTOR_PACKAGE_REQUEST";
export const FETCH_DOCTOR_WEIGHTING_RESULTS_REQUEST = "FETCH_DOCTOR_WEIGHTING_RESULTS_REQUEST";
export const UPDATE_DOCTOR_IGNORE_SPECIALTIES_REQUEST = "UPDATE_DOCTOR_IGNORE_SPECIALTIES_REQUEST";
export const CREATE_DOCTOR_HEALTH_TAG_REQUEST = "CREATE_DOCTOR_HEALTH_TAG_REQUEST";
export const UPDATE_DOCTOR_HEALTH_TAG_REQUEST = "UPDATE_DOCTOR_HEALTH_TAG_REQUEST";
export const DELETE_DOCTOR_HEALTH_TAG_REQUEST = "DELETE_DOCTOR_HEALTH_TAG_REQUEST";
export const CREATE_DOCTOR_APPROACH_REQUEST = "CREATE_DOCTOR_APPROACH_REQUEST";
export const UPDATE_DOCTOR_APPROACH_REQUEST = "UPDATE_DOCTOR_APPROACH_REQUEST";
export const DELETE_DOCTOR_APPROACH_REQUEST = "DELETE_DOCTOR_APPROACH_REQUEST";
export const FETCH_DOCTOR_WALLET_LIST_REQUEST = "FETCH_DOCTOR_WALLET_LIST_REQUEST";
export const UPDATE_DOCTOR_WALLET_BALANCE_REQUEST = "UPDATE_DOCTOR_WALLET_BALANCE_REQUEST";
export const FETCH_DOCTOR_WALLET_LOG_REQUEST = "FETCH_DOCTOR_WALLET_LOG_REQUEST";
export const UPDTAE_ASSESSMENT_INTERPRETATION_ENABLED_REQUEST = "UPDTAE_ASSESSMENT_INTERPRETATION_ENABLED_REQUEST";
